import { DurabilitySFDRDurableOnly } from '../../../../types';
export var list = [
    DurabilitySFDRDurableOnly.YES,
    DurabilitySFDRDurableOnly.NO,
];
